customElements.get("delivery-message") || customElements.define("delivery-message", class extends HTMLElement {
  constructor() {
    super(), this.cacheElements();
    const t = this.querySelector("[data-delivery-option-data]");
    try {
      this.data = t?.innerHTML ? JSON.parse(t.innerHTML) : null;
    } catch (t) {
      console.error("Failed to parse delivery data:", t), this.data = null;
    }
    if (this.excludedDatesSet = new Set, this.memoizedDeliveryDates = new Map, this.cutoffHour = null, 
    this.data && this.data.cutoff) {
      const t = new Date(this.data.cutoff);
      this.cutoffHour = t.getUTCHours();
    }
    this.dayNameToNumber = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6
    }, this.excludedDaysOfWeek = new Set, this.data && this.data.days_excluded && Array.isArray(this.data.days_excluded) && this.data.days_excluded.forEach(t => {
      const e = this.dayNameToNumber[t];
      void 0 !== e && this.excludedDaysOfWeek.add(e);
    }), this.locale = window.Shopify && window.Shopify.locale ? `${window.Shopify.locale}${window.Shopify.country ? "-" + window.Shopify.country : ""}` : document.documentElement.lang || navigator.language || "en", 
    this.monthFormatterLong = new Intl.DateTimeFormat(this.locale, {
      month: "long",
      timeZone: "UTC"
    }), this.monthFormatterShort = new Intl.DateTimeFormat(this.locale, {
      month: "short",
      timeZone: "UTC"
    });
  }
  cacheElements() {
    this.elements = Object.fromEntries(Object.entries({
      cutoffEl: "[data-delivery-cutoff-container]",
      countdownEl: "[data-delivery-countdown-container]",
      genericEl: "[data-delivery-generic-container]",
      regularContainerEl: "[data-delivery-container]",
      countdownTextEl: "[data-delivery-countdown]"
    }).map(([t, e]) => [ t, this.querySelector(e) ])), this.elements.dateEls = this.querySelectorAll("[data-delivery-date]"), 
    this.elements.dateRangeEls = this.querySelectorAll("[data-delivery-date-range]");
  }
  formatCountdown(t, e, a) {
    const i = window.strings.timeUnitAbbreviation, s = [];
    if (t > 0 && s.push({
      value: t,
      unit: "hour"
    }), e > 0 && s.push({
      value: e,
      unit: "minute"
    }), a > 0 && s.push({
      value: a,
      unit: "second"
    }), 0 === s.length) return `0${i.second}`;
    const n = s.slice(0, 2).map(t => `${t.value}${i[t.unit]}`);
    return 2 === n.length ? `${n[0]} ${window.strings.conjunction} ${n[1]}` : n.join("");
  }
  updateCountdown(t) {
    const {countdownTextEl: e} = this.elements;
    if (!e) return !1;
    const a = new Date, i = 3600 * (t - a.getUTCHours()) - 60 * a.getUTCMinutes() - a.getUTCSeconds();
    if (i < 0 || i < 60) return e.textContent = this.formatCountdown(0, 1, 0), !1;
    const s = Math.floor(i / 3600), n = Math.floor(i % 3600 / 60), o = i % 60;
    return e.textContent = this.formatCountdown(s, n, o), !0;
  }
  toggleVisibility(t, e) {
    t && (t.classList.toggle("hidden", !e), t.classList.toggle("opacity-0", !e), t.setAttribute("aria-hidden", String(!e)));
  }
  formatDateForExclusion(t) {
    return t.toISOString().split("T")[0].replace(/-/g, "/");
  }
  isDateExcluded(t) {
    const e = this.formatDateForExclusion(t), a = t.getUTCDay();
    return this.excludedDatesSet.has(e) || this.excludedDaysOfWeek.size > 0 && this.excludedDaysOfWeek.has(a);
  }
  calculateDeliveryDate(t, e, a) {
    const i = `${t}-${e.toISOString().split("T")[0]}-${e.getUTCHours()}-${a}`;
    if (this.memoizedDeliveryDates.has(i)) return new Date(this.memoizedDeliveryDates.get(i));
    const s = new Date(e);
    null !== a && e.getUTCHours() >= a && s.setUTCDate(s.getUTCDate() + 1);
    let n = 0;
    for (;n < t; ) s.setUTCDate(s.getUTCDate() + 1), this.isDateExcluded(s) || n++;
    return this.memoizedDeliveryDates.set(i, s.toISOString()), s;
  }
  formatDeliveryDate(t, e = {
    includeDay: !0,
    shortMonth: !1,
    includeMonth: !0
  }) {
    const {includeDay: a, shortMonth: i, includeMonth: s} = e, n = this.locale;
    if (!1 !== e.useNaturalLanguage && this.shouldUseNaturalDayName(t)) return this.formatNaturalDayName(t);
    const o = {
      day: a ? "numeric" : void 0,
      month: s ? i ? "short" : "long" : void 0
    };
    let l = new Intl.DateTimeFormat(n, o).format(t);
    if (a && n.startsWith("en")) {
      const t = t => t + ({
        one: "st",
        two: "nd",
        few: "rd",
        other: "th"
      }[new Intl.PluralRules(n, {
        type: "ordinal"
      }).select(t)] || "th");
      l = l.replace(/\b(\d{1,2})\b/, (e, a) => t(Number(a)));
    }
    return l;
  }
  shouldUseNaturalDayName(t) {
    const e = new Date, a = Math.ceil((t - e) / 864e5);
    return a > 0 && a <= 7;
  }
  formatNaturalDayName(t) {
    const e = new Date, a = Math.ceil((t - e) / 864e5);
    if (1 === a) return "tomorrow";
    if (a <= 7) {
      const i = new Intl.DateTimeFormat(this.locale, {
        weekday: "long",
        timeZone: "UTC"
      }).format(t), s = new Date(e);
      s.setUTCDate(e.getUTCDate() - e.getUTCDay()), s.setUTCHours(0, 0, 0, 0);
      const n = new Date(s);
      return n.setUTCDate(s.getUTCDate() + 6), n.setUTCHours(23, 59, 59, 999), t >= s && t <= n && a > 1 ? `this ${i}` : i;
    }
    return this.formatDeliveryDate(t, {
      useNaturalLanguage: !1
    });
  }
  updateElementContent(t, e) {
    t && null !== e && t.forEach(t => {
      t.textContent !== e && (t.textContent = e);
    });
  }
  updateDisplay() {
    if (!this.data) return;
    const t = new Date, {minimum_days: e, maximum_days: a, dates_excluded: i, cutoff: s} = this.data;
    0 === this.excludedDatesSet.size && i && i.split(",").map(t => t.trim()).forEach(t => this.excludedDatesSet.add(t));
    const n = this.cutoffHour;
    (!this.lastDateUpdate || t - this.lastDateUpdate >= 6e4) && (this.updateDeliveryDates(t, e, a, n), 
    this.lastDateUpdate = t), this.updateVisibility(t, n);
  }
  isMonthBeforeDay() {
    if (void 0 !== this._monthBeforeDay) return this._monthBeforeDay;
    const t = new Intl.DateTimeFormat(this.locale, {
      year: "numeric",
      month: "short",
      day: "numeric"
    }).formatToParts(new Date), e = t.findIndex(t => "month" === t.type), a = t.findIndex(t => "day" === t.type);
    return this._monthBeforeDay = e < a, this._monthBeforeDay;
  }
  updateDeliveryDates(t, e, a, i) {
    const {dateEls: s, dateRangeEls: n} = this.elements, o = this.calculateDeliveryDate(a, t, i), l = this.formatDeliveryDate(o);
    if (s.length > 0 && this.updateElementContent(s, l), n.length > 0) {
      const a = this.calculateDeliveryDate(e, t, i);
      if (a.getUTCMonth() === o.getUTCMonth() && a.getUTCFullYear() === o.getUTCFullYear() && a.getUTCDate() === o.getUTCDate()) return void this.updateElementContent(n, this.formatDeliveryDate(o, {
        includeDay: !0,
        shortMonth: !0,
        includeMonth: !0
      }));
      const s = this.shouldUseNaturalDayName(a), l = this.shouldUseNaturalDayName(o);
      let r, d;
      if (s && l) r = this.formatNaturalDayName(a), d = this.formatNaturalDayName(o); else if (s || l) this.isMonthBeforeDay(), 
      r = this.formatDeliveryDate(a, {
        includeDay: !0,
        shortMonth: !0,
        includeMonth: !0,
        useNaturalLanguage: !1
      }), d = this.formatDeliveryDate(o, {
        includeDay: !0,
        shortMonth: !0,
        includeMonth: !0,
        useNaturalLanguage: !1
      }); else {
        const t = this.isMonthBeforeDay();
        r = this.formatDeliveryDate(a, {
          includeDay: !0,
          shortMonth: !0,
          includeMonth: t,
          useNaturalLanguage: !1
        }), d = this.formatDeliveryDate(o, {
          includeDay: !0,
          shortMonth: !0,
          includeMonth: !t,
          useNaturalLanguage: !1
        });
      }
      this.updateElementContent(n, `${r} - ${d}`);
    }
  }
  updateVisibility(t, e) {
    e && t.getUTCHours() < e ? this.elements.countdownEl ? (this.updateCountdown(e), 
    this.toggleVisibility(this.elements.cutoffEl, !1), this.toggleVisibility(this.elements.countdownEl, !0), 
    this.toggleVisibility(this.elements.genericEl, !1)) : (this.toggleVisibility(this.elements.cutoffEl, !0), 
    this.toggleVisibility(this.elements.genericEl, !1)) : (this.toggleVisibility(this.elements.genericEl, !0), 
    this.toggleVisibility(this.elements.cutoffEl, !1), this.toggleVisibility(this.elements.countdownEl, !1)), 
    this.toggleVisibility(this.elements.regularContainerEl, !0);
  }
  connectedCallback() {
    this.data && (this.data.dates_excluded && this.data.dates_excluded.split(",").map(t => t.trim()).forEach(t => this.excludedDatesSet.add(t)), 
    this.updateDisplay(), this.updateInterval = setInterval(() => {
      this.updateDisplay();
    }, 1e3));
  }
  disconnectedCallback() {
    clearInterval(this.updateInterval), this.updateInterval = null, this.excludedDatesSet.clear(), 
    this.excludedDaysOfWeek.clear(), this.data = null, this.elements = null;
  }
});